import { goURL } from '../../../webmodule-common/other/ui/resource-resolver';
export const resourceProject = 'project';
export async function launchProject(id: string): Promise<boolean> {
  goURL(resourceProject, id);
  return true;
}
